const generateDefaultOption = (item: string) => ({
  value: item,
  label: item,
});

export const DURATIONS = ["3m", "6m", "9m", "12m", "18m", "24m", "36m"];

export const DEFAULT_END_DATE_DURATION = "3m";

export const DURATION_OPTIONS = DURATIONS.map(generateDefaultOption);

export const SUGGESTED_EXAM_CADENCE = ["3w", "6w", "16w", "5m", "6m"];

export const SUGGESTED_EXAM_CADENCE_OPTIONS = SUGGESTED_EXAM_CADENCE.map(
  generateDefaultOption
);

export const TYPE = ["ROM", "Dynamic", "Both"];

export const TYPE_OPTIONS_ENABLED = ["ROM"];

export const TYPE_OPTIONS = TYPE.map(generateDefaultOption);

export const GOALS = ["2w", "3w", "6w", "12w", "5m", "6m", "9m", "12m"];

export const GOALS_OPTIONS = GOALS.map(generateDefaultOption);

export const WEIGHT_BEARING = ["None", "WBAT", "PWB", "TDWB"];

export const TARGET_JOINT = ["Left Knee", "Right Knee"];

export const TARGET_JOINT_OPTIONS = TARGET_JOINT.map(generateDefaultOption);

export const WEIGHT_BEARING_OPTIONS = WEIGHT_BEARING.map(generateDefaultOption);

export const EXTENSION_OPTIONS = [
  { value: "0 - 0", label: "0 - 0", withDegree: true },
  { value: "Full", label: "Full" },
];

export enum TextFieldMaskENUM {
  examCadence = "^[0-9]+(w|m|y)?$",
  extension = "^[0-9]+ ?-? ?([0-9]+)?$",
}
